// extracted by mini-css-extract-plugin
module.exports = {"container":"_11jTtuVkHxTdHv7FQ39gId","stars":"_2wU6aVyX6RWisAZCdr95Nj","link":"_1UcSGr2DWylx2whGUPwYTN primaryBorderColor primaryColor"};